import { Suspense, lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router';
import { AppShell } from './components/layout/AppShell.tsx';
import { EmptyNote, Loading } from './components/ui/feedback.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { PrivacyPage } from './pages/privacy/PrivacyPage.tsx';
import { ProfilePage } from './pages/profile/ProfilePage.tsx';
import { SubscriptionPage } from './pages/SubscriptionPage.tsx';

// The editor carries react-native-web and the whole generator; it loads only on its own route.
const SignaturePage = lazy(() => import('./pages/SignaturePage.tsx').then((module) => ({ default: module.SignaturePage })));

const signature = (
  <Suspense fallback={<Loading label="Loading the editor…" />}>
    <SignaturePage />
  </Suspense>
);

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: signature },
      { path: 'signature', element: signature },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'subscription', element: <SubscriptionPage /> },
      // The three pages Privacy & security replaced; their addresses still work.
      { path: 'devices', element: <Navigate to="/privacy#devices" replace /> },
      { path: 'shared-emails', element: <Navigate to="/privacy#shared" replace /> },
      { path: 'settings', element: <Navigate to="/privacy#delete" replace /> },
      { path: '*', element: <EmptyNote>Page not found</EmptyNote> },
    ],
  },
]);
